import gql from "graphql-tag";
import AssetDiscussionCommentReplyFields from "../../fragments/AssetDiscussionCommentReplyFields";

export default gql`
  mutation ReplyToAssetDiscussionComment($commentId: ObjectID!, $bodyAsPlainText: String!) {
    replyToAssetDiscussionComment(commentId: $commentId, bodyAsPlainText: $bodyAsPlainText) {
      _id
      ...AssetDiscussionCommentReplyFields
    }
  }

  ${AssetDiscussionCommentReplyFields}
`;
